import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=cf093008&scoped=true"
import script from "./FormData.vue?vue&type=script&lang=js"
export * from "./FormData.vue?vue&type=script&lang=js"
import style0 from "./FormData.vue?vue&type=style&index=0&id=cf093008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf093008",
  null
  
)

export default component.exports